import React from "react";

const AudioPath = ({data, me}) => {
  return (
    <div className={`msg-bubble ${me ? 'msg-bubble-human' : ''}`}>
      <div className="message-container">
        <div className="message-wrapper  message-wrapper-bot msg-video"
             style={{animationFillMode: 'none !important'}}>
          <audio controls style={{maxWidth: '233px'}}>
            <source src={data.audio.url}/>
            Your browser does not support the audio element.
          </audio>
        </div>
        <div className="time" style={{fontSize: '9px'}}>{data.dateTime}</div>
      </div>
    </div>
  )
}

export default AudioPath;
